module.exports = __webpack_public_path__ + "img/img_gfx@2x (3).c6e6c134.png";